// export const baseUrl ="https://app.njseptic.com:8443/njseptic/auth/";
export const devUrl ="https://app.njseptic.com:8443/";
export const auth = "njseptic/auth"
export const njsApp = "njsepticapp"
export const login = auth + "/signin"
export const gelAllInspections = njsApp + "/inspection"
export const serviceProgram = njsApp + "/serviceprogram/"
export const serviceProgramTechnicalOnboarding = njsApp + "/sptechnicalonboarding"
export const pumpOutSchedule = njsApp + "/pumpoutschedule/" 
export const questions = njsApp + "/inspectionquestionsfirstpage?id="
export const pumpoutquestionsfirstpage = njsApp + "/pumpoutquestionsfirstpage?id="
export const pumpoutquestionssecondsystemfirstpage = njsApp + "/pumpoutquestionsscndsystemfirstpage?id="
export const inspectionquestions = njsApp + "/inspectionquestions?id="
export const updateinspection = njsApp + "/updateinspection/"
export const servicequestions = njsApp + "/servicequestionsByPage/v2?id="
export const sitesurveyquestions = njsApp + "/sitesurveyquestions?id="
export const pumpoutquestions = njsApp + "/pumpoutquestions?id="
export const locationUrl = "https://www.google.com/maps/search/?api=1&query="
export const photoUploadUrl = "njsepticapp/upload?id="
export const updateValues = njsApp + "/updateinspection/"
export const serviceUpdate = njsApp + "/updateserviceprogramv2/"
export const updateSurvey = njsApp + "/updatesitesurvey/"
export const updatePumpOut = njsApp + "/updatepumpout/"
export const submitReport = "njseptic/completeServiceProgram/"
export const submitSurvey = "njseptic/completeSiteSurvey/"
export const submitPumpoutReport = "njseptic/completePumpOut/"
export const submitInspection = "njseptic/completeInspection/"
export const notify = "njseptic/notifyOnTheWay/"
export const notifySiteSurvey = "njseptic/notifySiteSurvey/"
export const notifyPumpOut = "njseptic/notifyPumpOut/"
export const viewPhoto = njsApp + "/getimage?townshipId="
export const uploadPresentation = "njseptic/generateinspectionppt/"